import apiFetch from '../services/apiFetch';
import { CompraCredito, ParamsRemoto } from '../interfaces/CompraCredito';
import { TransacoesResponse } from "../types";

const compraCredito = async (dados: CompraCredito) => {
    try {
        return await apiFetch('/lojista/comprar_credito.php', {
            method: 'POST',
            body: JSON.stringify(dados),
        });
    } catch (error) {
        console.error('Erro ao comprar crédito:', error);
    }
};

const carteira = async (dados: ParamsRemoto) => {
    try {
        return await apiFetch(`/lojista/carteira_lojista.php?id_remoto=${dados.id_remoto}`, {
            method: 'POST',
            body: JSON.stringify(dados),
        });
    } catch (error) {
        console.error('Erro ao buscar carteira:', error);
    }
};

const transacciones = async (
    { id_remoto }: { id_remoto: string }
): Promise<TransacoesResponse> => {
    try {
        const params = new URLSearchParams({ id_remoto });
        return await apiFetch(`/lojista/historico_transacoes.php?${params.toString()}`);
    } catch (error) {
        console.error("Erro ao buscar transações:", error);
        throw error;
    }
};

export {
    compraCredito,
    carteira,
    transacciones
};
